module.exports = __webpack_public_path__ + "img/cart.90e5f969.svg";